import { uniqueId } from '../../../../lib/uniqueId';

export const newEmptyField = (): AutomationActionField => ({
  _id: uniqueId(),
  _fieldIds: [],
  fieldType: '',
  value: '',
});
